<template>
<v-app class="survey-container">

    <v-layout class="bg-light-blue" row wrap>
      <v-flex xs12>
        <NavBarHome></NavBarHome>
        <div>
          <v-banner v-if="impersonation" class="impersonation-banner yellow lighten-2">
            <v-avatar
              slot="icon"
              color="deep-orange accent-4"
              size="40">
              <v-icon color="white">
              people_alt
              </v-icon>
            </v-avatar>
            You are viewing the survey of <strong>{{officeDescription}}</strong>.
            <template v-slot:actions>
              <v-btn color="deep-orange accent-4 white--text" @click="exit()">Exit</v-btn>
            </template>
       </v-banner>
        </div>
        <div class="content">
          <h1>Survey Submitted</h1>

          <p class="content-detail">
            Thank you for submitting the survey.  To log out, you can click on the 'Sign Out' button at top right corner of the screen or simply close your browser.
          </p>

        </div>
      </v-flex>
    </v-layout>

    <Footer></Footer>

</v-app>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue';
import router from '@/router';
import { authTokenService } from '@/services/authTokenService.js';
import { NavBarHome } from '@/components/NavBarHome.vue';
import { footer } from '@/components/Footer.vue';
import { answerService } from '../services/answerService';
import { surveyService } from '@/services/surveyService';
import { utilityService } from '@/services/utilityService';
import { officeManagementService } from "@/services/officeManagementService.js";

export default {
  name: 'SurveySubmit',
  props: {
    value: Number,
  },
  data: () => ({
    impersonation: false,
    officeDescription: '',
    activeId:null,
    claims:null,
    officeId:null,
  }),
  watch: {

  },
  mounted () {
    const me = this;
    me.activeId = authTokenService.getActiveSurveyId();
    me.claims = authTokenService.getClaims();
    if(me.claims.userName == "Admin")
    {
      authTokenService.setNotaAdmin(false);
    }
    me.nonAdmin = authTokenService.getNotaAdmin();
    if(me.nonAdmin != "true") //means in case of admin
    {
      if (me.claims.role != undefined && me.claims.role.includes('Admin')) {
        me.impersonation = true;
      } else if (me.claims.surveyId != undefined && typeof me.claims.surveyId === 'string') {
        me.impersonation = me.claims.surveyId !== me.activeId;
      } else if (me.claims.surveyId != undefined && typeof me.claims.surveyId === 'object') {
        me.impersonation = !me.claims.surveyId.includes(me.activeId);
      }
      officeManagementService.getOfficeBySurveyId(me.activeId).then(function (response) {
        if (response && response.data) {
          me.officeDescription = response.data.description;
          me.officeId = response.data.id;
        }
		  });
    }
  },
  methods: {
  },
  computed: {
  },
}
</script>

<style scoped>
.survey-container  {
  width: 100%;
  margin: 0 auto;
}
.content {
  padding: 3% 3% 3% 5%;
  text-align: left;
}
.content-header {
  font-weight: bold;
}
.content-detail {
  font-weight: normal;
}
.v-text-field >>> input {
  text-align: left;
  padding: 3px;
  min-width: 150px;
}
h1 {
  margin: 20px 0 !important;
  padding: 0 !important;
  border: none !important;
  font-size: 20pt;
  font-style: normal;
  font-weight: bold;
}
h2 {
  font-size: 16pt;
  font-weight: normal;
}
h3 {
  font-size: 14pt;
  font-weight: normal;
  color: #c55911;
}
a {
  font-weight: bold;
}
</style>
